import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import SignupSection from "./components/SignupSection";
import SocialSection from "./components/SocialSection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  return (
    <main className="min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <HeroSection />
      <AboutSection />
      <SignupSection />
      <SocialSection />
      <FooterSection />
    </main>
  );
}
